import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import {
  BatchNrcMarcContentRegPageLoadResult,
  BatchNrcMarcContentRegPageLoadResultFromJSON
} from '@/api/models/batch/BatchNrcMarcContentRegPageLoadResult'
import {
  BatchNrcMarcContentRegRequest,
  BatchNrcMarcContentRegRequestToJSON
} from '@/api/models/batch/BatchNrcMarcContentRegRequest'

export class BatchNrcMarcContentRegApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchNrcMarcContentRegPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchNrcMarcContentRegPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  async createNrcMarcContentRegist(
    request: BatchNrcMarcContentRegRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/bibliography/regist-nrc-marc-content`,
      BatchNrcMarcContentRegRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
